import { Component, OnInit, Input  } from '@angular/core';
import { Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FormField } from '../../../../models/form-field';
import { FormFieldDropdown } from '../../../../models/form-field-dropdown';
import { MatDialogRef } from '@angular/material';
import { VolvoApiService } from '../../../../services/volvo-api.service';
import { FormControlService } from '../../../../services/form-control.service';

@Component({
  selector: 'app-request-info',
  templateUrl: './request-info.component.html',
  styleUrls: ['./request-info.component.scss']
})
export class RequestInfoComponent implements OnInit {

  @Input() Guid: string;
  @Input() CountryID: number;
  @Input() localStrings: Array<any>;
  @Input() code: string;
  @Input() SpecialOfferRequestInformation: any;

  requestForm: FormGroup;
  formRows: Array<Array<FormField<any>>> = [];
  selectDealerRow: Array<FormField<any>>;
  private dealers: Observable<any>;
  private states: Observable<any>;
  private dealerDropdown: FormFieldDropdown;
  private stateDropdown: FormFieldDropdown;
  private dealerData = [];
  private requestInfoBizFormFields: any;
  hasOptin: boolean;
  hasPreferredMethod: boolean;
  private methodOptions: Array<any>;
  errorMessages: Array<any>;
  formInvalidMessage: string | null;
  public formSubmitAttempt: boolean;
  submitSuccess = false;
  requestFormFields: any;
  showForm = false;

  constructor(
    private volvoApi: VolvoApiService,
    private dialogRef: MatDialogRef<RequestInfoComponent>,
    private _fb: FormBuilder,
    private _fs: FormControlService
  ) { }

  // load the form later to prevent ios from detecting and focus on input
  ngAfterViewInit() {
    setTimeout(() => {
      this.showForm = true;
    }, 400);
  }

  ngOnInit() {
    if (window.innerHeight > 900) { this.showForm = true; }

    // create form
    const ls = this.localStrings;
    this.requestInfoBizFormFields = this.volvoApi.XMLObjectFromString(this.SpecialOfferRequestInformation).form.field;
    this.requestInfoBizFormFields.forEach(f => {
      if (f.column == 'OptIn' && f.visible) { this.hasOptin = true; }
      if (f.column == 'PreferredContactMethod' && f.visible) {
        this.hasPreferredMethod = true;
        const defaultValue = f.properties[0].defaultvalue[0];
        this.methodOptions = [];
        f.settings[0].Options[0].split('\n').forEach(el => {
          this.methodOptions.push({
            label: el,
            value: el,
            checked: (el === defaultValue)
          });
        });
      }
    });
    Array.prototype.push.apply(this.formRows, this._fs.getBasicInfoFields(ls, true));

    // state and zip code
    this.stateDropdown = this._fs.createDropDownField(
      'State',
      'column medium-6 form-control-wrapper',
      null,
      Validators.required,
      ls['AV.Promotions.lb.stateID'],
      ls['AV.Promotions.lb.stateID']
    );
    const zipCodeField = this._fs.createTextBox(
      'ZipCode',
      ls['AV.Promotions.lb.zipcode'],
      null,
      'column medium-6 form-control-wrapper',
      null,
      ls['AV.Promotions.lb.validation.zipcode'],
      ls['AV.Promotions.lb.validation.zipcode.invalid'],
      [Validators.required, this._fs.patternValidator(/(^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]( )?\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]\d$)|(^\d{5}(-\d{4})?$)/)]
    );
    this.formRows.push([this.stateDropdown, zipCodeField]);

    // email and phone number
    const emailField = this._fs.createTextBox(
      'emailinput',
      ls['AV.Promotions.lb.emailAddress'],
      null,
      'column medium-6 form-control-wrapper',
      null,
      ls['AV.Promotions.lb.validation.fromAddress'],
      ls['AV.Promotions.lb.validation.emailAddress.invalid'],
      [Validators.required, Validators.email]
    );
    const phoneField = this._fs.createTextBox(
      'PhoneNumber',
      ls['AV.Promotions.lb.phoneNumber'],
      null,
      'column medium-6 form-control-wrapper',
      null,
      ls['AV.Promotions.lb.validation.phoneNumber'],
      ls['AV.Promotions.lb.validation.phoneNumber.invalid'],
      [Validators.required, this._fs.patternValidator(/^(1[-. ]?)?(\([2-9]\d{2}\)|[2-9]\d{2})[-. ]?[2-9]\d{2}[-. ]?\d{4}(([xX]|ext|EXT)?\d{1,5})?$/)]
    );
    this.formRows.push([emailField, phoneField]);

    // preferred method
    if (this.hasPreferredMethod) {
      const preferredMethodField = this._fs.createRadioField(
        'PreferredContactMethod',
        ls['AV.Promotions.lb.contactMethod'],
        'Phone',
        null,
        this.methodOptions,
        Validators.nullValidator,
        ls['AV.Promotions.lb.contactMethod.required'],
      );
      this.formRows.push([preferredMethodField]);
    }

    // dealer dropdown
    this.dealerDropdown = this._fs.createDropDownField(
      'DealerCode',
      null,
      null,
      Validators.required,
      ls['AV.Promotions.lb.validation.partnerCode'],
      ls['AV.Promotions.lb.validation.partnerCode']
    );
    this.dealers = this.volvoApi.getAvailablePartners(this.Guid);
    this.dealers.subscribe(r => {
      r.forEach(d => {
        this.dealerData[d['Code']] = {
          'CompanyEmail': d['CompanyEmail'],
          'CompanyKeyContact': d['CompanyKeyContact'],
          'CompanyKeyContactEmail': d['CompanyKeyContactEmail'],
        };
      });
      this.dealerDropdown.options = this._fs.createOptionsObj(r, 'Code', ls['AV.Promotions.lb.dealerSelectText']);

      // select if there is only one option
      if (r.length == 1) {
        this.dealerDropdown.options[1].selected = true;
        this.requestForm.controls['DealerCode'].setValue(this.dealerDropdown.options[1].key);
      } else {
        // if dealer code is set
        if (this.code) {
          this.dealerDropdown.options.map(opt => {
            if (opt.key === this.code) {
              opt.selected = true;
              this.requestForm.controls['DealerCode'].setValue(opt.key);
            } else {
              opt.selected = false;
            }
            return opt;
          });
        }
      }

    });
    this.selectDealerRow = [this.dealerDropdown];

    // load states dropdown list
    this.states = this.volvoApi.getStates(this.CountryID);
    this.states.subscribe(r => {
      this.stateDropdown.options = this._fs.createOptionsObj(r, 'Name', ls['AV.Promotions.lb.stateID']);
    });

    this.createForm();

  }

  get optin() { return this.requestForm.get('OptIn'); }

  createForm() {
    // console.log(this.formRows);
    this.requestForm = this._fs.toFormGroup(this.formRows);

    // register static form control fields
    this.requestForm.addControl('OptIn', new FormControl('', Validators.nullValidator));
    this.requestForm.controls['OptIn'].setValue(false);
    this.requestForm.addControl('DealerCode', new FormControl('', Validators.nullValidator));

  }

  onSubmit() {

    if (this.requestForm.valid) {
      this.formSubmitAttempt = true;
      const formData = this.requestForm.value;
      formData.promotionGuid = this.Guid;
      const dealerInfo = this.dealerData[formData.DealerCode];
      formData.CompanyEmail = dealerInfo.CompanyEmail;
      formData.CompanyKeyContact = dealerInfo.CompanyKeyContact;
      formData.CompanyKeyContactEmail = dealerInfo.CompanyKeyContactEmail;

      this.volvoApi.saveBizForm(JSON.stringify(formData), 'SaveSpecialOfferRequestInfo')
        .subscribe(r => {
          if (r.Success) {
            
            this.formSubmitAttempt = false;
            this.submitSuccess = true;
            setTimeout(() => {
              this.dialogRef.close();
            }, 7500);
          } else {
            this.errorMessages = r.errorMessages;
          }
        });
    } else {
    }

  }

  clickSubmit() {
    if ( this._fs.validateForm(this.requestForm) ) {
      this.formInvalidMessage = null;
      this.onSubmit();
    } else {
      this.formInvalidMessage = this.localStrings['AV.Promotions.lb.formSubmitInvalid'];
    }
  }

}
